
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.productInput = this.form.querySelector('[name="id"]') || this.form.querySelector('[name="items[0][id]"]')
      this.productInput.disabled = false;
      this.submitButton = this.querySelector('[name="submit"]') || this.querySelector('[data-original-submit]') || this.querySelector('[name="add"]');
      this.submitButton.addEventListener('click', this.onSubmitHandler.bind(this));
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.cartNotification = document.querySelector('cart-notification')

    }

    slugify(str) {
      str = str.replace(/^\s+|\s+$/g, '');
      str = str.toLowerCase();
      str = str.replace(/[^a-z0-9 -]/g, '')
              .replace(/\s+/g, '-')
              .replace(/-+/g, '-');
      return str;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      
      if (this.submitButton.classList.contains('loading')) return;

      this.handleErrorMessage()

      if(!window.matchMedia('(max-width: 600px)').matches) {
        this.cartNotification.setActiveElement(document.activeElement)
      }

      this.submitButton.setAttribute('aria-disabled', true)
      this.submitButton.classList.add('loading')

      const formData = new FormData(this.form)

      const sections = this.cartNotification
        .getSectionsToRender()
        .map((section) => section.id);

      const sections_url = window.location.pathname;

      const personalizationBlockId = this.dataset.personalizationBlockId
      const personalizationBlock = document.getElementById(personalizationBlockId)
      const itemsToAdd = [];

      const id = Number(formData.get('id'));
      const quantity = Number(formData.get('quantity'));

      itemsToAdd.push({
        id: id,
        quantity: quantity,
        properties: {}
      })
      
      if (personalizationBlockId && personalizationBlock) {
        const persoText = personalizationBlock.querySelector('#perso_text')
        const persoRadio = personalizationBlock.querySelector('#perso_radio')
        const connectedString = personalizationBlock.querySelector('.connected-perso-strings')
        const persoOptionExist = persoText?.value?.trim() || persoRadio

        if (personalizationBlock && persoOptionExist) {
          let persoFilled = false
          const uuid = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);
          let persoId = `${id}_${uuid}`;
          const persoProperties = {}
          
          if (persoRadio && persoText && persoText.value.trim()) {
            persoId = `${persoId}_${this.slugify(persoText.value)}`;
            persoProperties[this.slugify(persoText.dataset.name)] = persoText.value

            const radioPlaceholder = persoRadio.dataset.placeholder
            if (!radioPlaceholder || radioPlaceholder.trim() !== persoRadio.value.trim()) {
              persoId = `${persoId}_${this.slugify(persoRadio.value)}`;
              persoProperties[this.slugify(persoRadio.dataset.name)] = persoRadio.value
              persoFilled = true
            }
          }    

          if (persoFilled) {
            persoProperties["_personalization"] = true
            itemsToAdd[0].properties[connectedString.textContent.trim()] = connectedString.dataset.personalizedIndicator
            itemsToAdd.push({
              id: Number(personalizationBlock.dataset.persoProductId),
              quantity: quantity,
              properties: {
                [connectedString.textContent.trim()]: connectedString.dataset.productTitle,
                ...persoProperties
              }
            })
            itemsToAdd.forEach(item => {
              item.properties["_perso"] = persoId
            });
          }
        }
      }      

      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: itemsToAdd,
          sections: sections.toString(),
          sections_url
        })
      }
      
      fetch(`${routes.cart_add_url}.js`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            console.log('error')
            return;
          }

          this.cartNotification.renderContents(response)

          document.body.classList.add('cart-opened')

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading')
          this.submitButton.removeAttribute('aria-disabled')
          // google tag manager event
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
          'event' : 'Add to cart'
          });
        });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
